import request from '@/utils/request'
const platform = localStorage.getItem('platform')

export function getAppEventAssetTasks(data) {
    return request.get(`/${platform}/app_event_asset_tasks`, data)
}

export function retryAppEventAssetTask(id) {
    return request.patch(`/${platform}/app_event_asset_tasks/${id}/retry`)
}

export function addAppEventAssetEvents(data) {
    return request.post(`/${platform}/app_event_asset_tasks/events`, data)
}
